import { prop } from "../../decorators/property";
import { FullTextSourceModel } from "../../desktop/models/full-text-source";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { SearchCitationSourceModel } from "../../search/models/search-citation-source";

@backboneModelProperties({
    relations : [{
        type: Backbone.Many,
        key: "FullTextSources",
        relatedModel: FullTextSourceModel
    }],
    defaults: {
        FullTextSources: []
    }
})
export class ParallelCitationModel extends Backbone.AssociatedModel {

    @prop() public FullTextSources: Backbone.Collection<FullTextSourceModel>;
    @prop() public Source: SearchCitationSourceModel;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/parallel-citation.ts